export const Key = {
  token: 'access_token',
  profile: 'admin_profile',
}
